export const MoneyConversions = {

	/*
	**  Set the methods
	*/

	filters: {

		convertDollarsToCents: function(value) {

			return value * 100;

		},

		convertCentsToDollars: function(value) {

			// Set the var
			let dollars = value / 100;

			// Add the formatting
			dollars = Number(dollars).toFixed(2).toLocaleString();

			return dollars;

		}

	}

}